import { PaidServiceStageIds } from './../../../common/types/paidService';
export const COLORS = {
  [PaidServiceStageIds.DEFINITION]: '#C9007A',
  [PaidServiceStageIds.CALCULATE_NEED]: '#FB000D',
  [PaidServiceStageIds.CALCULATE_PREPARATION]: '#6C0AAB',
  [PaidServiceStageIds.CALCULATE_CHECK]: '#97266A',
  [PaidServiceStageIds.CHECK]: '#BC2F36',
  [PaidServiceStageIds.WAITING_PAYMENT]: '#e08701',
  [PaidServiceStageIds.COMPLETING_WORK]: '#5D2680',
  [PaidServiceStageIds.CORRECT_CALCULATION_PREPARATION]: '#83004F',
  [PaidServiceStageIds.CORRECT_CALCULATION_CHECK]: '#A30008',
  [PaidServiceStageIds.ADDITIONAL_CHECK]: '#45036F',
  [PaidServiceStageIds.UPD]: '#E439A1',
  [PaidServiceStageIds.DRAFTING_CONTRACT_FOR_SPECIFYING_SERVICES]: '#FD3F49',
  [PaidServiceStageIds.GET_SCAN_OF_SIGNED_CONTRACT]: '#9A3FD5'
}
 